import { routes } from 'navigation/routing';

export const routesWithoutMobileHeader = [routes.hockeyChallenge];
export const iconVariant = 'cancel';
